/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/ui/dialogs/ConfirmationDialog'
], function (APIFactory, ContentActionsProviderAPI, ConfirmationDialog) {

	class ResetDashboardAction {

		constructor({ features }) {
			this._dashboard = features.API;
			const contentActions = features.ContentActions;
			this._features = features;

			this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			contentActions.registerProvider('ResetDashboard', this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		_isItemVisible() {
			const contentView = this._dashboard.getCurrentContentView();
			const isThereASavedInst = !!contentView.getSavedInstance();
			const isDirty = this._features['DashboardState'].getUiState().dirty;
			return isThereASavedInst && isDirty;
		}

		_resetDashboard() {
			const contentView = this._dashboard.getCurrentContentView();
			const savedInstance = contentView.getSavedInstance();
			contentView.clearTransientState();

			const extOptions  = {
				isAuthoringMode: false,
				clearDirtyFlag: true
			};
			return contentView.reloadFromJSONSpec(JSON.parse(savedInstance), extOptions);
		}

		_onReset() {
			const contentView = this._dashboard.getCurrentContentView();
			const stringService = contentView.stringService;
			const resetMessage = stringService.get('dashboardResetToast');
			const dlg = new ConfirmationDialog({
				title: stringService.get('dashboardResetTitle'),
				message: stringService.get('dashboardResetMessage'),
				confirmCallback: () => {
					return this._resetDashboard().then(() => {
						// After resetting dashboard, the ResetDashboardAction will be destroyed,
						// so the action has already been destroyed at this point, and this._dashboard
						// is undefined, so we need to get the new dashboard api from the content view
						return contentView.getDashboardApi().showToast(resetMessage, {
							type: 'success',
							preventDuplicates: true
						});
					});
				}
			});
			dlg.render();
		}

		getContentActionList() {
			const contentView = this._dashboard.getCurrentContentView();
			const stringService = contentView.stringService;
			const uiState = this._features['DashboardState'].getUiState();
			if (uiState.authoring === false && this._isItemVisible() && uiState.dirty) {
				return [{
					name: 'ResetDashboard',
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.DASHBOARD,
					order: 70,
					label: stringService.get('dashboardResetTitle'),
					icon: this._features['Icons'].getIcon('restore').id,
					actions: {
						apply: () => { return this._onReset(); }
					}
				}];
			} else {
				return [];
			}
		}
	}
	return ResetDashboardAction;
});
